'use strict';

define(['app'], function (app) {

  var productSizeGuide = function productSizeGuide() {
    var component = {};

    var _config = {
      selectors: {
        productSizeGuideButton: '[data-size-guide-button]',
        modalContainer: '[data-modal-container]',
        closeButton: '[data-modal-close]'
      },
      classes: {
        showModalClass: 'productSizeGuide_modalContainer_show'
      },
      label: {
        descriptionComponentClickedPosition: 'productSizeGuide component clicked button',
        clicked: 'Clicked'
      }
    };

    var _init = function _init(element) {
      component.element = element;
      component.modal = component.element.querySelector(component.config.selectors.modalContainer);
      component.addListeners();
      return component;
    };

    var _addListeners = function _addListeners() {
      var button = component.element.querySelector(component.config.selectors.productSizeGuideButton);
      button.addEventListener('click', component.openModal);
      button.addEventListener('click', component.trackButtonClicked);
      var closeButton = component.element.querySelector(component.config.selectors.closeButton);
      closeButton.addEventListener('click', component.closeModal);
      component.modal.addEventListener('click', component.closeModal);
    };

    var _openModal = function _openModal(e) {
      e.preventDefault();
      app.element.addClass(component.config.classes.showModalClass, component.modal);
    };

    var _closeModal = function _closeModal(e) {
      e.preventDefault();
      if (e.target === e.currentTarget) {
        app.element.removeClass(component.config.classes.showModalClass, component.modal);
      }
    };

    var _trackButtonClicked = function _trackButtonClicked() {
      app.publish('tracking/record', 'Product | Size Guide', component.config.label.clicked, component.config.label.descriptionComponentClickedPosition);
    };

    component.config = _config;
    component.init = _init;
    component.addListeners = _addListeners;
    component.openModal = _openModal;
    component.closeModal = _closeModal;
    component.trackButtonClicked = _trackButtonClicked;

    return component;
  };

  return productSizeGuide;
});
//# sourceMappingURL=productSizeGuide.js.map
